import classNames                                from 'classnames';
import React, { PropsWithChildren }              from 'react';
import { StyledContainer, StyledContainerProps } from "@src/views/containers";


interface MagicColorContainerProps extends PropsWithChildren<any>, StyledContainerProps {
    isActive?: boolean,
    animated?: boolean,
    colorSet?: string[],
}

const MagicColorContainerDefaultProps = {
    isActive: true,
    animated: true,
    colorSet: [
        '#ee7752',
        '#e73c7e',
        '#2c82bc',
        '#23d5ab',
        '#2c82bc',
        '#e73c7e',
        '#ee7752'
    ]
} satisfies Partial<MagicColorContainerProps>;

function MagicColorContainer( { children, ...p }: MagicColorContainerProps ){

    const { style = {}, className = [], isActive, animated, ...props } = { ...MagicColorContainerDefaultProps, ...p };

    const generateColorSetStyle = ( colorSet: string[] ) => {
        return `linear-gradient(-45deg, ${ colorSet.join( ', ' ) })`;
    };


    return (
        <StyledContainer
            className={
                classNames(
                    {
                        'position--relative': true,
                        'animate-bg-45deg':   animated,
                        'bg--colored-black':  !isActive,
                    },
                    className )
            }
            style={ isActive ? {
                backgroundSize:    '600% 600%',
                backgroundImage:   generateColorSetStyle( props.colorSet ),
                animationDuration: '60s',
                ...style
            } : style }
            { ...props }>

            { children }

        </StyledContainer>
    );
}

export {
    MagicColorContainer,
    MagicColorContainerDefaultProps,
    type MagicColorContainerProps,
};
